import React from 'react'
import { Table, Button } from 'reactstrap'

import { Link } from 'react-router-dom'


interface GameTableProps {
  gameData: any[],
  onDeleteGame: (gameId: string) => void
}

const GameTable = (props: GameTableProps) => {
  const { gameData, onDeleteGame } = props
  return (
    <Table>
      <thead>
        <tr>
          <th>Game</th>
          <th>Private</th>
          <th>Start</th>
          <th>Round</th>
          <th>Players</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {
          gameData.map((g: any, i: number) => (
            <tr key={g.id}>
              <td><Link to={'/play/'+g.id} >{g.id}</Link></td>
              <td>{g.IsPrivate}</td>
              <td>{g.DateStart}</td>
              <td>{g.RoundCurrent} / {g.RoundTotal}</td>
              <td>
              <Link to={'/join/'+g.id} >Join</Link><br/>
              <Link to={'/result/'+g.id} >Results</Link>
              </td>
              <td><Button color="link" onClick={() => onDeleteGame(g.id)}>Delete</Button></td>
            </tr>
          ))
        }
      </tbody>
    </Table>
  )

}
export default GameTable
